export default "__VITE_ASSET__DMOJT3bU__"